export default __webpack_public_path__ + "static/media/04-customer-journey.18ba6bf7.svg";